
import React, {createElement, FC, Fragment} from 'react';
import {LINK_EXT} from 'constants/index';
import rehypeExternalLinks from 'rehype-external-links';
import rehypeRaw from 'rehype-raw';
import rehypeReact from 'rehype-react';
import rehypeSlug from 'rehype-slug';
import remarkBreaks from 'remark-breaks';
import remarkParse from 'remark-parse';
import remarkLint from 'remark-preset-lint-recommended';
import remarkRehype from 'remark-rehype';
import {unified} from 'unified';

import {TrackLink} from './Link';

interface MarkdownProps {
	className?: string;
	markdown: string;

	// Options; default unset
	nl2br?: boolean;
	linkify?: boolean;
	spanify?: boolean;

	track?: string;
}

export const Markdown: FC<MarkdownProps> = ({className, markdown, ...opts}) => {
	const preBr = unified()
		.use(remarkParse)
		.use(remarkLint);

	const postBr = opts.nl2br ? preBr.use(remarkBreaks) : preBr;
	const component = postBr
		.use(remarkRehype)
		.use(rehypeSlug)
		.use(rehypeRaw)
		.use(rehypeExternalLinks, LINK_EXT() as object)
		.use(rehypeReact, {
			...{createElement, Fragment},
			components: {
				'a': opts.linkify ? 'a': TrackLink(opts.track),
				'p': opts.spanify ? 'span' : 'p',
			},
		})
		.processSync(markdown)
		.result;

	if (!className) {
		return component;
	}

	return (
		<div className={className}>
			{component}
		</div>
	);
};
